import CanvasSequence from './CanvasSequence.js';
const symbols = Object.freeze({
    sequence: Symbol.for('sequence'),
    push: Symbol.for('push'),
});
function replaceTags(str, values) {
    const tag = str.replace(/^\{|\}$/gu, '');
    if (tag !== str) {
        return values.hasOwnProperty(tag) ? values[tag] : tag;
    }
    return str;
}
class CanvasBlueprint extends CanvasSequence {
    build(values = {}) {
        const seq = new CanvasSequence();
        this[symbols.sequence].forEach(({ type, inst, args }) => {
            const realArgs = args.map((v) => {
                return (typeof v === 'string') ? replaceTags(v, values) : v;
            });
            seq[symbols.push](type, inst, realArgs);
        });
        return seq;
    }
    execute() {
        throw new TypeError('Cannot execute a blueprint.');
    }
}
export default CanvasBlueprint;
